import LangSwitcher from "./lang-switcher";

export default LangSwitcher;